import { ApiError } from 'generated';
const notAuthenticated = (error: ApiError) =>
  error.status === 401 ||
  error.status === 403 ||
  error.name === 'UnauthorizedError';

export default notAuthenticated;
